<style lang="sass">
Table
  text-align: center
.top
  margin: 30px auto
.pages
  margin: 30px auto
</style>
<template>
    <Card>
            <div class="search-div">
                <Input class="input-div" placeholder="请输入广告标题名称搜索" clearable v-model="searchObj.ad_title" ></Input>
                <!-- <SearchModelNew placeholderText='请选择广告位称搜索' class="input-div" :isMultiple="2"  :url="config.urlArray.ggSearchPosition"  labelName="name"  valName="id" v-model="searchObj.position_id" keyword="keyword"  ></SearchModelNew> -->
                
               
                
                <Button  type="primary" @click="searchItem" style="margin-left:8px;">搜索</Button>
            </div>
            <Button type="success" :disabled="buttonList.addDisabled" @click="addData(1)" style="margin-right:8px;">添加</Button>
            <Button type="primary" :disabled="buttonList.editDisabled" @click="addData(2)" style="margin-right:8px;">修改</Button>
            <Button type="error" :disabled="buttonList.editDisabled" @click="delData">删除</Button>

         <Table :columns="titleName" :data="tableList.tableData" @on-sort-change="sortCustom" ref="selection" @on-selection-change="selectChange" ></Table>
          <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[10,20,30,50]" placement="top" class="pages"/>
          <!-- 编辑 / 添加  模态框组件 -->
           <ModelBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>
           <!-- 广告添加 -->
           <AdModelBox :showAdModel.sync="adBox.showAdModel" :pos_type="adBox.pos_type" :type="1" :editFormData="{}" :pos_id="adBox.posid" :fn="adBox.callbackAdFn"></AdModelBox>
           <!-- 删除弹框组件 -->
           <DeleteDialog ref="deleteChild" @ievent = "ievent"></DeleteDialog>
    </Card>
</template>

<script>
import expandRow from './table-ad-expand.vue';
import common from '@/common/common.js';
import ModelBox from './addModel';
import AdModelBox from './addAdModel';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
    export default {
        name: "addadAdmin",
        components: {
            expandRow, //引入伸缩组件
            ModelBox,
            AdModelBox,
            DeleteDialog
        },
        data(){
            return{
                loading: true,
                type:1,//弹框打开类型 1添加 2编辑
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                adBox:{//广告弹框组
                    posid:0,//上级广告位的ID
                    showAdModel:false,//广告弹框开关
                    pos_type:1,
                    callbackAdFn:()=>{}, //广告弹框的回调函数
                },
                addBox:{//广告位弹框组
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                buttonList:{//按钮组
                    addDisabled:false,//添加按钮是否禁用
                    editDisabled:true,//编辑按钮是否禁用
                    delDisabled:true,//删除按钮是否禁用
                },
                page:{//分页排序
                    total:0,//总条数
                    pageSize:20,//每页条数
                    current:1,//当前页
                    key:'sort_num',
                    order:'desc'
                },
                 searchObj:{
                    ad_title:"",
                },
                titleName: [
                    { //多选框
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    { // 伸缩框
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h(expandRow, {
                                props: {
                                    ref:'son',
                                    params: params,
                                }
                            })
                        }
                    },
                    {
                        title: '广告位',
                        key: 'ad_title',
                        sortable: 'custom'
                    },
                    {
                        title: '尺寸',
                        key: 'ad_size'
                    },
                    {
                        title: '类型',
                        key: 'type_id',
                        sortable: 'custom',
                        render: (h, params) => {
                            let typeStr = params.row.type_id == 1?'图片':'代码/文字'
                            return h('span', typeStr);
                        }
                    },
                    {
                        title: '排序',
                        key: 'sort_num',
                        sortable: 'custom'
                    },
                    {
                        title: '状态',
                        key: 'status',
                        sortable: 'custom',
                        render: (h, params) => {
                            let color = '#13C351'
                            let status = '正常'

                            switch (params.row.status){
                                case 1:
                                color = '#13C351'
                                status = '显示'
                                break
                                case 2:
                                color = '#f00'
                                status = '隐藏'
                                break
                                default:
                                color = '#f00'
                                status = '未知'

                            }
                            return h('span', {style:{color:color}},status);
                        }
                    },
                    {
                        title: '添加时间',
                        key: "created_at",
                        sortable: 'custom',
                        minWidth:150,
                    },
                    {
                        title: '操作',
                        key: "id",
                        render: (h, params) => {
                            return h('Button', {
                                props: {
                                    type: "primary",
                                    },
                                on: {
                                    click: () => { this.addAdData(params) }//添加广告位广告
                                }

                            },"添加广告")
                        }
                    }
                ]
            }
        },
        methods: {
            searchItem(){
                this.getData()
            },
            getData () {//获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        pagesize:this.page.pageSize,
                        sortfield:this.page.key,
                        ascDesc:this.page.order
                        }
                }
                Object.assign(getData.params,this.searchObj)
                this.axios.get(this.config.urlArray.positionShow,getData).then((result) => {
                    common.ajaxMsg(result.data);
                    let resData = result.data.data.list
                    //处理数组
                    this.tableList.tableData = resData
                    this.page.total = result.data.data.total
                    this.loading = false
                }).catch((err) => {
                    common.msg('error','广告位获取失败',()=>{})
                });
            },
            addData (type) {  //添加或编辑数据
                this.type = type
                if(type == 2){
                    this.addBox.editFormData = this.tableList.hasSelectData
                }
                this.addBox.showModel = true
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            //删除单条广告位
            delData () {
                this.$refs.deleteChild.showit();
            },
            ievent(val) {
                let getData = {
                    id:this.tableList.hasSelectData.id,
                    merchant_id:0
                }
                this.axios.post(this.config.urlArray.positionDestroy,getData).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.clearbtnStatus();
                        this.getData()
                        this.$refs.deleteChild.recancel();
                    })
                }).catch((err)=>{
                    common.msg('error','删除失败')
                })
            },
            addAdData (params) {  //添加或编辑广告
                this.adBox.showAdModel = true
                this.adBox.posid = params.row.id
                this.adBox.pos_type = params.row.type_id
                this.adBox.callbackAdFn = () => {//回调处理
                    //重新载入
                    this.adBox.showAdModel = false;
                }
            },
            /**以下方法不用变 */
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
            selectChange(res){ //控制编辑和删除按钮的可用状态
                if(res.length == 1){
                    this.buttonList.editDisabled = this.buttonList.delDisabled = false
                    this.tableList.hasSelectData = res[0]
                }else{
                    this.buttonList.editDisabled = this.buttonList.delDisabled = true
                    this.tableList.hasSelectData = {}
                }
            },
            clearbtnStatus(){ //删除后清空编辑数据  与按钮状态
                this.buttonList.delDisabled = true
                this.buttonList.editDisabled = true
                this.addBox.editFormData ={}
                this.tableList.hasSelectData = {}
            }
        },
        created (){
            this.getData()
        }
    }
</script>
